import {styledByTheme} from "../../../../../../themes/architecture/styled-by-theme";
import {LogoVipImageDefaultBox} from "./vip-logo-icon.default.box";
import {LogoVipImageDefaultBoxCasino777} from "./vip-logo-image.casino777.box";
import {LogoVipImageDefaultBoxHarringtonDelawareBallysDover} from "./vip-logo-image.harrington.delaware.ballysdover.box";
import {LogoVipImageSIBox} from "./vip-logo-image.si.box";
import {LogoVipImageDefaultBoxHarrash} from "./vip-logo-icon.harrahs.box";
import {LogoVipImageDefaultBoxWSOP} from "./vip-logo-image.wsop.box";


export const LogoVipImageBox = styledByTheme(LogoVipImageDefaultBox)
                                .forCasino777(LogoVipImageDefaultBoxCasino777)
                                .forDelawarePark(LogoVipImageDefaultBoxHarringtonDelawareBallysDover)
                                .forHarrington(LogoVipImageDefaultBoxHarringtonDelawareBallysDover)
                                .forBallysDover(LogoVipImageDefaultBoxHarringtonDelawareBallysDover)
                                .forHarrahs(LogoVipImageDefaultBoxHarrash)
                                .forWsop(LogoVipImageDefaultBoxWSOP)
                                .forSI(LogoVipImageSIBox)
                                .apply();